<template>
	<div class="cursor-pointer">
		<Tooltip v-if="value === 'added'" :content="t('favouriteSKUsPanel.unmarkFavourite')" :show-delay="500">
			<Icon name="star" size="1.25" class="text-message-warning" @click="emit('remove')" />
		</Tooltip>

		<Tooltip v-else-if="value === 'removed'" :content="t('favouriteSKUsPanel.markFavourite')" :show-delay="500">
			<Icon name="star-outline" size="1.25" @click="emit('add')" />
		</Tooltip>

		<Tooltip v-else-if="value === 'partially-added'" :content="t('favouriteSKUsPanel.markFavourite')" :show-delay="500">
			<Icon name="star-half-full" class="text-message-warning" size="1.25" @click="emit('add')" />
		</Tooltip>
	</div>
</template>

<script setup lang="ts">
import { Icon, Tooltip, useTranslation } from '@bluebrick/saas-ui'

const { t } = useTranslation()

defineProps<{
	value: 'added' | 'removed' | 'partially-added'
}>()

const emit = defineEmits(['add', 'remove'])
</script>
